"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useAccordion = useAccordion;
exports.Accordion = Accordion;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var __jsx = _react["default"].createElement;

function useAccordion() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sections = props.sections,
      _props$oneAtATime = props.oneAtATime,
      oneAtATime = _props$oneAtATime === void 0 ? false : _props$oneAtATime; // Hook uncontrolled right now

  var _useState = (0, _react.useState)(sections.map(function (s) {
    return s.isOpenAtInit || false;
  })),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var newSections = sections.map(function (section, index) {
    var open = function open() {
      var newIsOpen = (0, _toConsumableArray2["default"])(isOpen); //
      // if (oneAtATime) {
      //     newIsOpen = new Array(sections.length).fill(false);
      // }

      newIsOpen[index] = true;
      setOpen(newIsOpen);
    };

    var close = function close() {
      var newIsOpen = (0, _toConsumableArray2["default"])(isOpen);
      newIsOpen[index] = false;
      setOpen(newIsOpen);
    };

    var toggle = function toggle() {
      if (isOpen[index]) {
        close();
      } else {
        open();
      }
    };

    return {
      open: open,
      close: close,
      toggle: toggle,
      buttonProps: {
        onClick: function (_onClick) {
          function onClick() {
            return _onClick.apply(this, arguments);
          }

          onClick.toString = function () {
            return _onClick.toString();
          };

          return onClick;
        }(function () {
          toggle();

          if (sections.onClick) {
            onClick.apply(void 0, arguments);
          }
        }),
        selected: isOpen[index]
      },
      showHideProps: {
        isOpen: isOpen[index]
      }
    };
  });
  return {
    sections: newSections
  };
}

function AccordionSection(props) {}

function Accordion(props) {
  var children = props.children,
      controller = props.controller,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["children", "controller"]);
  children = _react["default"].Children.toArray(children);
  var sections = [];
  children.forEach(function (child, index) {
    if (child.type === AccordionSection) {
      var grandChildren = _react["default"].Children.toArray(child.props.children);

      var _child$props = child.props,
          isOpenAtInit = _child$props.isOpenAtInit,
          _restProps = (0, _objectWithoutProperties2["default"])(_child$props, ["isOpenAtInit"]);

      sections.push({
        button: grandChildren[0],
        showHide: grandChildren[1],
        headerAs: child.props.headerAs || "h6",
        isOpenAtInit: isOpenAtInit,
        props: _restProps
      });
    }
  });

  if (!controller) {
    controller = useAccordion((0, _objectSpread2["default"])({
      sections: sections.map(function (section) {
        return {
          isOpenAtInit: section.isOpenAtInit
        };
      })
    }, props));
  }

  var i = 0;
  return __jsx(_Box["default"], restProps, children.map(function (child, index) {
    if (child.type === AccordionSection) {
      var section = sections[i];
      var sectionController = controller.sections[i];
      i++;
      return __jsx(_Box["default"], (0, _extends2["default"])({}, section.props, {
        key: child.key || index
      }), __jsx(_Box["default"], {
        as: section.headerAs
      }, _react["default"].cloneElement(section.button, sectionController.buttonProps)), _react["default"].cloneElement(section.showHide, sectionController.showHideProps));
    }

    return child;
  }));
}

Accordion.Section = AccordionSection;
var _default = Accordion;
exports["default"] = _default;